import { useQuery } from "@tanstack/react-query";
import { publicCustomerUserClient } from "../../api";
import { GLOBAL_QUERY_STALE_TIME } from "../../common/queries";
import { CPInvitationInfo } from "../../api/models/unified";

export const inviteKey = "inviteKey";

const getInviteQueryKeyBuilder = (invitationId: string) => [
  inviteKey,
  invitationId,
];

export const useGetInvitationValidationQuery = (invitationId?: string) => {
  return useQuery<CPInvitationInfo>({
    queryKey: getInviteQueryKeyBuilder(invitationId ?? ""),
    queryFn: () =>
      publicCustomerUserClient.validateInvitationGuid(invitationId ?? ""),
    enabled: !!invitationId,
    staleTime: GLOBAL_QUERY_STALE_TIME,
  });
};
